module.exports = __webpack_public_path__ + "img/loader.c2a788af.png";